import type { IBatchStore } from './batch-store-types';
import { playAudio } from '../../components/Sound';

export const notificationMixin = {

  showSnackbar(this: IBatchStore, message: any, options?: any): void {
    this.rootStore.notifierStore.showSnackbar(message, options);
  },

  showSuccess(this: IBatchStore, message: any, delay = 3000, options?: any): void {
    this.showSnackbar(message, { variant: 'success', autoHideDuration: delay, ...options });
    const { isOnline } = this.rootStore.connectionStore;
    if (isOnline) {
      playAudio();
    }
  },

  showInfo(this: IBatchStore, message: any, delay = 3000, options?: any): void {
    this.showSnackbar(message, { variant: 'info', autoHideDuration: delay, ...options });
    const { isOnline } = this.rootStore.connectionStore;
    if (isOnline) {
      playAudio();
    }

    if (!this.replayMode && this.canEmit && this.pacConnected && !this.remoteControl) {
      this.saveLog(`n-info ${typeof message === 'string' ? message : message?.key}`);
    }
  },

  showWarning(this: IBatchStore, message: any, delay = 4000, options?: any): void {
    this.showSnackbar(message, { variant: 'warning', autoHideDuration: delay, ...options });
    const { isOnline } = this.rootStore.connectionStore;
    if (isOnline && delay > 1000) {
      playAudio();
    }

    if (!this.replayMode && this.canEmit && this.pacConnected && !this.remoteControl) {
      this.saveLog(`n-warning ${typeof message === 'string' ? message : message?.key}`);
    }
  },

  showError(this: IBatchStore, message: any, delay = 5000, options?: any): void {
    this.showSnackbar(message, { variant: 'error', autoHideDuration: delay, ...options });

    if (!this.replayMode && this.canEmit && this.pacConnected && !this.remoteControl) {
      this.saveLog(`n-error ${typeof message === 'string' ? message : message?.key}`);
    }
  },

};
